import { Field } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { StepLayout } from "../components/StepLayout";
import { focusWithoutPan } from "../focusWithoutPan";

export interface EmailStepProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  /** Either the local "that isn't an address" or the server's "already taken". */
  errorText?: string;
}

export function EmailStep({ value, onChange, onSubmit, errorText }: EmailStepProps) {
  const { t } = useTranslation("client");

  return (
    <StepLayout
      title={t(
        "onboarding.email.title",
        "Mihin sähköpostiin tavoitamme sinut tulosten ja tuen tiimoilta?",
      )}
    >
      <Field
        label={t("onboarding.email.label", "Sähköposti")}
        type="email"
        inputMode="email"
        autoComplete="email"
        autoCapitalize="none"
        spellCheck={false}
        placeholder={t("onboarding.email.placeholder", "sinä@esimerkki.fi")}
        value={value}
        errorText={errorText}
        onChange={(e) => onChange(e.target.value)}
        onMouseDown={focusWithoutPan}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSubmit();
        }}
      />
    </StepLayout>
  );
}
